import { SCI_PALETTE } from "@/lib/science/sci-chart";
import { cartesianAxis, PlotShell } from "@/lib/science/sci-plot";
import { m } from "@/paraglide/messages";

const EXAMPLE =
  "Category,2023,2024\nAlpha,42,55\nBeta,30,48\nGamma,58,40\nDelta,25,35";

export function BarPlot() {
  return (
    <PlotShell
      toolId="bar-chart"
      inputLabel={m.plot_input_label()}
      placeholder={m.bar_placeholder()}
      example={EXAMPLE}
      exampleLabel={m.plot_load_example()}
      hint={m.plot_hint_empty()}
      buildOption={(data, theme) => {
        const multi = data.colHeaders.length > 1;
        return {
          tooltip: { trigger: "axis" },
          legend: multi
            ? {
                data: data.colHeaders,
                bottom: 0,
                textStyle: { color: theme.muted },
              }
            : undefined,
          grid: { left: 48, right: 20, top: 20, bottom: multi ? 44 : 30 },
          xAxis: {
            type: "category",
            data: data.rowLabels,
            ...cartesianAxis(theme),
          },
          yAxis: { type: "value", ...cartesianAxis(theme) },
          series: data.colHeaders.map((name, ci) => ({
            name,
            type: "bar",
            data: data.matrix.map((row) =>
              Number.isFinite(row[ci]) ? row[ci] : null,
            ),
            itemStyle: {
              color: SCI_PALETTE[ci % SCI_PALETTE.length],
              borderRadius: [3, 3, 0, 0],
            },
          })),
        };
      }}
    />
  );
}
